<template>
  <div>
    <strong class="entry-title">{{entry.title}}</strong>
    <p></p>
    <truncate class="description" collapsedTextClass="collapsed" clamp="read more" less="read less" :text="entry.description" :length="150" v-if="entry.description"></truncate>
  </div>
</template>

<script>
import truncate from 'vue-truncate-collapsed';

export default {
  name: 'WhatsHappeningNonMeetingEntry',
  props: ['entry'],
  components: { truncate }
}
</script>

<style scoped="">
  .title {
    font-size: 1.3em;
  }
</style>
